// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_l2-0";